// a place to keep lodash extensions

_.mixin({

  // Purpose: exact behavior as _.chunk() only allows for a filler
  // so that each sub-array is of the same length
  //
  // Example:
  //
  // let x = [1,2,3,4,5,6,7,8];
  //
  // _.chunk(x, 3)
  //   => [[1,2,3], [4,5,6], [7,8]]
  //
  // _.chunkWithFiller(x, 3, null)
  //   => [[1,2,3], [4,5,6], [7,8,null]]
  //
  'chunkWithFiller': (collection, size, filler) => {
    if (!collection.length) { return []; }

    let newCollection  = _.chunk(collection, size),
        collectionSize = newCollection.length,
        lastItem       = newCollection[collectionSize - 1],
        lastItemSize   = lastItem.length;

    // fill the last array with the filler, if need be
    while (lastItemSize < size) {
      lastItem.push(filler);
      lastItemSize++;
    }

    // replace the last item in the array with the filled version
    newCollection[collectionSize - 1] = lastItem;

    return newCollection;
  }

});